(function() {
  function initVrc(root) {
    if (!root || root.dataset.vrcBound === 'true') return;
    root.dataset.vrcBound = 'true';
    
      
      

      const viewport = root.querySelector('[data-vrc-viewport]');
      const track = root.querySelector('[data-vrc-track]');
      const prevBtn = root.querySelector('[data-vrc-prev]');
      const nextBtn = root.querySelector('[data-vrc-next]');
      const slides = root.querySelectorAll('.vrc__slide');

      if (viewport && track && slides.length > 1) {
        function getScrollStep() {
          const firstSlide = slides[0];
          if (!firstSlide) return viewport.clientWidth * 0.85;
          const trackStyles = window.getComputedStyle(track);
          const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);
          return firstSlide.getBoundingClientRect().width + gap;
        }

        function updateArrows() {
          if (!prevBtn || !nextBtn) return;
          const maxScroll = viewport.scrollWidth - viewport.clientWidth;
          const x = viewport.scrollLeft;
          prevBtn.disabled = x <= 2;
          nextBtn.disabled = x >= (maxScroll - 2);
        }

        function scrollByStep(dir) {
          const step = getScrollStep();
          viewport.scrollBy({ left: dir * step, behavior: 'smooth' });
        }

        if (prevBtn) prevBtn.addEventListener('click', function(){ scrollByStep(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function(){ scrollByStep(1); });

        let raf = null;
        viewport.addEventListener('scroll', function() {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(updateArrows);
        }, { passive: true });

        window.addEventListener('resize', updateArrows);
        updateArrows();
      }

      const shells = root.querySelectorAll('[data-video-shell]');

      function pauseOtherVideos(exceptVideo) {
        shells.forEach(function(shell) {
          const v = shell.querySelector('[data-review-video]');
          if (!v || v === exceptVideo) return;
          if (!v.paused) v.pause();
        });
      }

      function syncVideoState(shell, video) {
        if (!shell || !video) return;
        shell.classList.toggle('is-playing', !(video.paused || video.ended));
      }

      function animatePlayButton(btn) {
        if (!btn) return;
        btn.classList.remove('is-rotating');
        void btn.offsetWidth;
        btn.classList.add('is-rotating');
        window.setTimeout(function() {
          btn.classList.remove('is-rotating');
        }, 340);
      }

      shells.forEach(function(shell) {
        const video = shell.querySelector('[data-review-video]');
        const playBtn = shell.querySelector('[data-play-btn]');
        const tapHint = shell.querySelector('[data-tap-hint]');
        const posterFallback = shell.querySelector('[data-poster-fallback]');
        if (!video) return;

        function revealVideo() {
          video.classList.add('is-ready');
          if (posterFallback) posterFallback.classList.remove('is-visible');
        }

        function playVideo() {
          pauseOtherVideos(video);
          if (playBtn) animatePlayButton(playBtn);

          const p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function() {});
          }
        }

        function toggleVideo() {
          if (video.paused || video.ended) playVideo();
          else video.pause();
        }

        if (playBtn) {
          playBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            playVideo();
          });
        }

        video.addEventListener('click', function(e) {
          e.preventDefault();
          toggleVideo();
        });

        video.addEventListener('loadeddata', revealVideo, { once: true });
        video.addEventListener('canplay', revealVideo, { once: true });

        video.addEventListener('play', function() {
          syncVideoState(shell, video);
          if (tapHint) tapHint.style.opacity = '0';
        });

        video.addEventListener('pause', function() {
          syncVideoState(shell, video);
        });

        video.addEventListener('ended', function() {
          syncVideoState(shell, video);
          try { video.currentTime = 0; } catch(e) {}
        });

        if ('IntersectionObserver' in window && viewport) {
          const io = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (!entry.isIntersecting && !video.paused) {
                video.pause();
              }
            });
          }, { root: viewport, threshold: 0.35 });

          io.observe(shell);
        }

        syncVideoState(shell, video);
      });
    
  }
  function vrcBoot() {
    document.querySelectorAll('[id^="vrc-"]').forEach(initVrc);
  }
  vrcBoot();
  document.addEventListener('shopify:section:load', vrcBoot);
})();
